import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const Footer = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    if (id === "performance") {
      navigate("/performance");
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    if (id === "strategic-consulting") {
      navigate("/strategic-consulting");
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    if (id === "contact") {
      navigate("/contact");
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="ssg-footer"
      className="bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="mb-8">
              <img
                src="https://customer-assets.emergentagent.com/job_ssg-coaching/artifacts/pkgt7i93_489F0D9A-2A77-47CF-B54B-18E9E2CA80E0.png"
                alt="Smith Strategic Group"
                data-testid="footer-logo"
                className="w-40 h-40 md:w-48 md:h-48 object-contain -ml-2"
              />
            </div>
            <p className="font-display text-2xl md:text-3xl font-medium tracking-tight leading-snug max-w-xl text-neutral-200">
              Strategy for the leader becoming more.
            </p>
            <p className="mt-6 text-sm text-neutral-400 max-w-md leading-relaxed font-medium">
              A boutique coaching and strategy firm helping leaders and
              organizations close the gap between where they are and what
              they&apos;re capable of becoming.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#E25555] mb-6">
              Navigate
            </div>
            <ul className="space-y-3 text-sm text-neutral-300 font-medium">
              {[
                ["performance", "Performance Coaching"],
                ["strategic-consulting", "Strategic Consulting"],
                ["about", "About"],
                ["framework", "Free Framework"],
                ["ideal-client", "Ideal Client"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => go(id)}
                    className="ssg-link-underline hover:text-white"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#E25555] mb-6">
              Direct
            </div>
            <ul className="space-y-3 text-sm text-neutral-300 font-medium">
              <li className="text-neutral-500">Remote · United States</li>
              <li className="text-neutral-500">By introduction</li>
              <li>
                <button
                  data-testid="footer-cta-contact"
                  onClick={() => go("contact")}
                  className="ssg-link-underline hover:text-white text-neutral-300"
                >
                  Start the conversation →
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-neutral-500">
            © {year} Smith Strategic Group. All rights reserved.
          </div>
          <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-neutral-600">
            Designed in the open · Built with intention
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
